<template>
	<div>
		<h6 class="headline pa-2 mb-3 text-center">
			Dstr Signature Verification
		</h6>
		<v-card
			class="white--text pa-2 d-flex justify-space-between align-center body-2 full-width text-center"
			ripple
			:color="themeInputColor"
		>
			<div style="width: 40%">Name/UserId</div>
			<div style="width: 30%">City/State</div>
			<div style="width: 30%">Action</div>
		</v-card>
		<v-card
			v-if="!nonVerifiedSignatures.length"
			class="text-center pa-4 body-2"
			:loading="true"
		>
			<div>No pending signatures for verification</div>
		</v-card>
		<v-card
			v-for="{
				retailerName = '-',
				city = '-',
				state = '-',
				userId,
				signatureId
			} in nonVerifiedSignatures"
			:key="signatureId"
			class="pa-2"
		>
			<div class="d-flex justify-space-between align-center full-width">
				<div style="width: 40%">
					<div class="title">{{ retailerName }}</div>
					<div class="caption">{{ userId }}</div>
				</div>
				<div class="text-center" style="width: 30%">
					<div class="body-2">{{ city }}</div>
					<div>{{ state }}</div>
				</div>
				<div class="text-right" style="width: 30%">
					<v-btn
						:color="themeInputColor"
						@click.stop="openSignVerifyModal(signatureId)"
						class="white--text rounded-card"
						small
						>Action</v-btn
					>
				</div>
			</div>
		</v-card>
		<v-dialog width="600px" persistent v-model="signVerifyModal">
			<div class="white pos-rel pa-2 rounded-card">
				<v-btn
					small
					flat
					icon
					@click.stop="closeSignVerifyModal"
					class="float-right"
				>
					<v-icon size="24">close</v-icon>
				</v-btn>
				<h6 class="headline text-center">Signature</h6>
				<div class="text-center pa-4">
					<img
						height="180px"
						:src="selectedDstr.signatureUrl || ''"
						alt
					/>
				</div>
				<v-text-field
					v-model="remarks"
					label="Remarks"
					placeholder="Remarks (if rejected)"
					class="text-field-wrapper mx-4 pt-4 mb-3"
					filled
				/>
				<div class="d-flex justify-space-between align-center">
					<v-btn
						color="red darken-3"
						@click.stop="verifySignature(true)"
						class="white--text body-2 rounded-card py-3"
						small
						:loading="verifyingSignature === 2"
						>Reject</v-btn
					>
					<v-btn
						color="green darken-1"
						@click.stop="verifySignature()"
						class="white--text body-2 rounded-card py-3"
						small
						:disabled="!!remarks"
						:loading="verifyingSignature === 1"
						>Approve</v-btn
					>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import {
	GET_NON_VERIFIED_SIGNATURE,
	VERIFY_SIGNATURE
} from "../../../store/action-types";
import { THEME_INPUT_COLOUR } from "../../constants";

export default {
	data() {
		return {
			nonVerifiedSignatures: [],
			signVerifyModal: false,
			selectedDstr: {},
			verifyingSignature: 0,
			remarks: "",
			themeInputColor: THEME_INPUT_COLOUR
		};
	},
	mounted() {
		this.fetchNonVerifiedSignatures();
	},
	methods: {
		openSignVerifyModal(id) {
			this.selectedDstr =
				this.nonVerifiedSignatures.filter(
					dstr => dstr.signatureId === id
				)[0] || {};
			this.signVerifyModal = true;
		},
		closeSignVerifyModal() {
			this.signVerifyModal = false;
		},
		fetchNonVerifiedSignatures() {
			this.$store
				.dispatch(GET_NON_VERIFIED_SIGNATURE.dispatch, "finance")
				.catch(() => {})
				.then(data => {
					this.nonVerifiedSignatures = data;
				});
		},
		verifySignature(reject = false) {
			this.verifyingSignature = reject + 1;
			const { userId: dstrId = "", signatureId = "" } = this.selectedDstr;
			this.$store
				.dispatch(VERIFY_SIGNATURE.dispatch, {
					dstrId,
					id: signatureId,
					...(reject
						? { status: "INACTIVE", remarks: this.remarks }
						: {})
				})
				.catch(() => {})
				.finally(() => {
					this.fetchNonVerifiedSignatures();
					this.verifyingSignature = 0;
					this.signVerifyModal = false;
				});
		}
	}
};
</script>
<style scoped>
.rounded-card {
	border-radius: 8px;
}
.float-right {
	position: absolute;
	top: 2px;
	right: 2px;
}
</style>
